import { Html5Qrcode } from "html5-qrcode";
import React from 'react';

const qrcodeRegionId = "html5qr-code-full-region";

class Html5QrcodePlugin extends React.Component {

  render() {
    return <div id={qrcodeRegionId} />;
  }

  componentWillUnmount() {
    try {
      this.html5QrcodeScanner.stop().then(() => {
        this.html5QrcodeScanner.clear()
      }).catch(err => console.log(err))
    } catch (err) {

    }
  }

  async componentDidMount() {
    function createConfig(props) {
      var config = {};
      if (props.fps) {
        config.fps = props.fps;
      }
      if (props.qrbox) {
        config.qrbox = props.qrbox;
      }
      config.aspectRatio = 1.333334
      if (props.disableFlip !== undefined) {
        config.disableFlip = props.disableFlip;
      }
      return config;
    }

    var config = createConfig(this.props);

    if (!(this.props.qrCodeSuccessCallback)) {
      throw "qrCodeSuccessCallback is required callback.";
    }

    if (this.props.closeOLPN || this.props.tray) {
      this.html5QrcodeScanner = new Html5Qrcode(qrcodeRegionId);
      this.html5QrcodeScanner.start({ deviceId: { exact: this.props.device.deviceId } }, config,
        this.props.qrCodeSuccessCallback
      ).catch((err) => {

      });
    }
  }
};

export default Html5QrcodePlugin;
